var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 3.6V1.2C3.6 0.54 4.14 0 4.8 0H10.8C11.1183 0 11.4235 0.126428 11.6485 0.351472C11.8736 0.576516 12 0.88174 12 1.2V7.2C12 7.51826 11.8736 7.82348 11.6485 8.04853C11.4235 8.27357 11.1183 8.4 10.8 8.4H8.4V10.8C8.4 11.1183 8.27357 11.4235 8.04853 11.6485C7.82348 11.8736 7.51826 12 7.2 12H1.2C0.88174 12 0.576516 11.8736 0.351472 11.6485C0.126428 11.4235 0 11.1183 0 10.8V4.8C0 4.14 0.54 3.6 1.2 3.6H3.6ZM4.8 3.6H7.2C7.51826 3.6 7.82348 3.72643 8.04853 3.95147C8.27357 4.17652 8.4 4.48174 8.4 4.8V7.2H10.8V1.2H4.8V3.6ZM1.2 4.8V10.8H7.2V4.8H1.2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy2);
export default __webpack_public_path__ + "static/media/copy2.71237a007f9ef44299b41a3724e44414.svg";
export { ForwardRef as ReactComponent };